import React from "react"
import linkedneurons from "../images/linkedneurons.jpg"
import ciarp from "../images/ciarp.jpg"
import master from "../images/master.jpg"
import sepcons from "../images/sepcons.jpg"


import {FaExternalLinkAlt as ExternalLink, FaGithub as Github, FaMediumM as Medium} from "react-icons/fa"
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Keywords from './keywords'


const Abstract = (props) => (
    <div>
        <Card.Title className=" card-title-color mb-4">{props.title}</Card.Title>
        <Card className="px-4 py-2"
              style={{marginRight: '-4.5vw', position: "relative", zIndex: 10}}>
            <Card.Body>
                <p className={'author'} style={{float: "left", color: "#888"}}>{props.authors.join(', ')}</p>
                <p
                    className={'year'} style={{float: "right", color: "#888"}}>{props.year}</p>
                <div style={{clear: "both"}}></div>
                <p className="card-text text-justify">{props.children}</p>

            </Card.Body>
        </Card>
    </div>
);

class PublicationLinks extends React.Component {
    render() {
        let pdf;
        if (this.props.paper_url !== '') {
            pdf = <li>
                <a className="mr-4 icon" href={this.props.paper_url}>
                    <ExternalLink/>
                </a>
            </li>
        } else {
            pdf = '';
        }
        let medium;
        if (this.props.blog_url !== '') {
            medium = <a className="mr-4 icon" href={this.props.blog_url}>
                <Medium/>
            </a>
        } else {
            medium = ''
        }
        let github;
        if (this.props.code_url !== '') {
            github = <a className="mr-4 icon" href={this.props.blog_url}>
                <Github/>
            </a>
        } else {
            github = ''
        }


        return (
            <ul className={"paper-link-list"}>
                {pdf}
                {github}
                {medium}
            </ul>
        )
    }
}

const Screenshot = (props) => (
    <a href={props.children}>
        <img className="img-fluid" src={props.children}
             alt="{title} diagram"/>
    </a>
);

function Publication({children, title, authors, year, keywords, screenshot, paper_url, code_url, blog_url}) {

    return (
        <Container>
            <Row className="my-5 ">
                <Col className=" my-auto">
                    <Row>
                        <Abstract title={title} authors={authors} year={year}>{children}</Abstract>
                    </Row>
                    <Row>
                        <Keywords keywords={keywords}/>
                    </Row>
                    <Row>
                        <PublicationLinks paper_url={paper_url} code_url={code_url} blog_url={blog_url}/>
                    </Row>
                </Col>
                {/*<div className="w-100 d-block d-sm-none"></div>*/}
                <Col xs={12} sm={12} md={4} lg={5} className="d-flex justify-content-center">
                    <Screenshot>{screenshot}</Screenshot>
                </Col>
            </Row>
        </Container>
    )
}


export default () => (
    <Container as="section" id="publications">
        <h3  className={"section-title"} style={{textAlign: `left`}}>Publications</h3>

        <div className="separator pt-3">
            <Publication
            title={"Superseding Model Scaling by Penalizing Dead Units and Points with Separation Constraints"}
            authors={['Carles Riera', 'Camilo Rey-Torres', 'Eloi Puertas', 'Oriol Pujol']}
            year={2019}
            keywords={["Dead Point", "Dead Unit", "Model Scaling", "Separation Constraints"]}
            screenshot={sepcons}
            paper_url={''}
            code_url={''}
            blog_url={''}>
            In this article, we study a proposal that enables to train extremely thin (4 or 8 neurons per layer) and
            relatively deep (more than 100 layers) feedforward networks without resorting to any architectural
            modification such as Residual or Dense connections, data normalization or model scaling. We accomplish
            that
            by alleviating two problems. One of them are neurons whose output is zero for all the dataset, which
            renders
            them useless. This problem is known to the academic community as <i>dead neurons</i>. The other is a
            less
            studied problem, dead points. Dead points refers to data points that are mapped to zero during the
            forward
            pass of the network. As such, the gradient generated by those points is not propagated back past the
            layer
            where they die, thus having no effect in the training process. In this work, we characterize both
            problems
            and propose a constraint formulation that added to the standard loss function solves them both. As an
            additional benefit, the proposed method allows to initialize the network weights with constant or even
            zero
            values and still allowing the network to converge to reasonable results. We show very promising results
            on a
            toy, MNIST, and CIFAR-10 datasets.</Publication>

            <Publication
                title={"Solving internal covariate shift in deep learning with linked neurons"}
                authors={['Carles Riera', 'Oriol Pujol']}
                year={2017}
                keywords={["Neuron linkage", "Concatenated ReLU", "Convariate shift"]}
                screenshot={linkedneurons}
                paper_url={'https://arxiv.org/abs/1712.02609'}
                code_url={'https://github.com/blauigris/linked_neurons'}
                blog_url={''}>
                This work proposes a novel solution to the problem of internal covariate shift and dying neurons
                using
                the
                concept of linked neurons. We define the neuron linkage in terms of two constraints: first, all
                neuron
                activations in the linkage must have the same operating point. That is to say, all of them share
                input
                weights. Secondly, a set of neurons is linked if and only if there is at least one member of the
                linkage
                that has a non-zero gradient in regard to the input of the activation function. This means that
                for any
                input in the activation function, there is at least one member of the linkage that operates in a
                non-flat
                and non-zero area. This simple change has profound implications in the network learning
                dynamics. In
                this
                article we explore the consequences of this proposal and show that by using this kind of units,
                internal
                covariate shift is implicitly solved. As a result of this, the use of linked neurons allows to
                train
                arbitrarily large networks without any architectural or algorithmic trick, effectively removing
                the need
                of
                using re-normalization schemes such as Batch Normalization, which leads to halving the required
                training
                time. It also solves the problem of the need for standarized input data. Results show that the
                units
                using
                the linkage not only do effectively solve the aforementioned problems, but are also a
                competitive
                alternative with respect to state-of-the-art with very promising results.

            </Publication>
            <Publication
                title={"An Approximate Support Vector Machines Solver with Budget Control"}
                authors={['Carles Riera', 'Oriol Pujol']}
                year={2016}
                keywords={["SVM", "Budget", "#Supports Constraint"]}
                screenshot={ciarp}
                paper_url={'https://www.researchgate.net/publication/313784106_An_Approximate_Support_Vector_Machines_Solver_with_Budget_Control'}
                code_url={''}
                blog_url={''}>
                We propose a novel approach to approximately solve on-line kernel Support Vector Machines (SVM)
                with the
                number of support
                vectors set beforehand. To this aim, we modify the original formulation introducing a new
                constraint
                that penalizes the deviation with respect to the desired number of support vectors. The
                resulting
                problem is solved using stochastic subgradient methods with block coordinate
                descent. Comparison with state-of-the-art online methods shows very
                promising results.

            </Publication>
            <Publication
                title={"Sparse methods for Online Support Vector Machine"}
                authors={['Carles Riera', 'Oriol Pujol']}
                year={2016}
                keywords={["SVM", "Homotopy", "Continuation", "Pruning"]}
                screenshot={master}
                paper_url={'https://www.semanticscholar.org/paper/Sparse-methods-for-Online-Support-Vector-Machine-Molina-Roger/74ec2d084404dbe9faf62a3df87b8d80e09a3132'}
                code_url={''}
                blog_url={''}>
                This work proposes a new online classifier based on Kernel SVM that minimizes the number of
                support
                vectors thanks to an additional restriction imposed by means of continuation methods. We build
                an
                homotopy between a normal SVM formulation to a restricted one with threshold on the magnitude of
                the
                coefficients, tightening it iteratively. We show how the use of the continuation method helps in
                achieving solutions that would be
                unfeasible directly. Experimentation in UCI datasets show significant savings.

            </Publication>

        </div>
    </Container>
)